// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2ExzB","itemTitle":"ClientEmergencyInfo_itemTitle__2X0TB","itemText":"ClientEmergencyInfo_itemText__33gth"};